import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import PersonValidations from 'scaleflow/validators/person';
import { tracked } from '@glimmer/tracking';

export default class QuickAddsPersonComponent extends Component {
  @service store;
  @tracked isSaving = false;
  person = {
    name: '',
    abbreviation: '',
    active: true,
  };
  personValidations = PersonValidations;

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    this.isSaving = true;
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      let person = this.store.createRecord('person', {
        name: changeset.name,
        abbreviation: changeset.abbreviation,
        active: true,
      });
      await person.save();
      await this.store.findRecord('person', person.id);
      await this.args?.onItemSaved(person);
      this.isSaving = false;
      this.handleModalDismiss();
    } catch (err) {
      console.log('Error', err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss();
  }

  @action
  createAbbreviation(changeset) {
    changeset.set(
      'abbreviation',
      changeset.name.slice(0, 2).toUpperCase().padEnd(2, 'U'),
    );
  }
}
